import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import Colors from "/styles/colors";
import { BRAND_WORK_MANAGEMENT_PRIMARY_COLOR, WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";

export const careersCommonStyles = css`
  /* MOBILE SUPPORT */
  .desktop-only {
    display: block;
  }

  .mobile-only {
    display: none;
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: block;
    }
  }

  .careers-rnd-btn {
    color: white;
    font-size: 1rem;
    line-height: 100%;

    padding: 11px 30px 14px 30px;
    background: ${Colors[BRAND_WORK_MANAGEMENT_PRIMARY_COLOR]};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.101025);
    border-radius: 24px;

    &:hover,
    &:active {
      color: white;
    }
  }

  .card.card-news {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.100091);
    border-radius: 16px;

    .card-image {
      :global(img) {
        max-width: 100%;
        width: 100%;
      }
    }

    .card-content {
      > p {
        font-weight: bold;
        font-size: 1.594rem;
        line-height: 35px;
        /* or 125% */
        letter-spacing: -0.3px;
        color: #383b45;
        margin-bottom: 16px;
      }

      .card-footer {
        padding: 0;

        p {
          font-weight: normal;
          font-size: 0.8125rem;
          line-height: 22px;
          /* or 157% */
          margin-top: 10px;

          letter-spacing: -0.105px;

          /* 03 Text/Jaco */

          color: ${Colors.asphalt};
        }
      }
    }
  }
  /* MOBILE DESIGN */
  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    :global(.slick-dots) {
      :global(li) {
        width: 13px;

        :global(button) {
          background-color: #f2f3f4 !important;
          width: 12px !important;
          height: 12px !important;
        }
      }
      :global(li.slick-active) {
        :global(button) {
          background-color: ${Colors[WORK_OS_IRIS_COLOR_NAME]} !important;
        }
      }
    }

    /* CUSTOM ACCORDION - USED IN MOBILE CAREERS AND MOBILE POSITION PAGES */
    .accordion-holder {
      .accordion-header {
        cursor: pointer;

        :global(svg) {
          transform: rotate(90deg);
          position: absolute;
          right: 1.5em;
        }
      }

      .accordion-content {
        transition: 0.3s ease-in-out;
        max-height: 0px;
        overflow: hidden;
      }

      &.is-active {
        .accordion-header {
          :global(svg) {
            transform: rotate(270deg);
          }
        }
        .accordion-content {
          max-height: 1500px;
        }
      }
    }
  }
`;
